import { em } from 'polished'
import styled from 'styled-components'

import List from 'components/List'
import { BoxBase } from 'styles/components/layout'

export const BoxBaseStyled = styled(BoxBase)`
  overflow: hidden;
  position: relative;
  padding-top: ${em(80)};
  padding-bottom: ${em(80)};
  background: ${p => p.theme.colors.catskillWhite};
`

export const ContentRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${em(10)};
  margin-bottom: ${em(20)};
  max-width: 85%;

  ${p => p.theme.mq.upMd} {
    max-width: 70%;
    margin-bottom: ${em(65)};
  }

  ${p => p.theme.mq.upLg} {
    max-width: 40%;
    margin-bottom: ${em(40)};
  }
`

export const ListRow = styled.div`
  max-width: 100%;

  ${p => p.theme.mq.upMd} {
    max-width: 35%;
  }

  ${p => p.theme.mq.upLg} {
    max-width: 30%;
    display: flex;
    align-items: center;
  }
`

export const StyledList = styled(List)`
  margin-bottom: ${em(40)};
`
